import { INITIATE_TRACKING, UPDATE_CURRENT_LOCATION, TERMINATE_TRACKING } from './types'

export const initiateTracking = () => ({ type: INITIATE_TRACKING })

export const updateCurrentLocation = location => ({
    type: UPDATE_CURRENT_LOCATION,
    payload: location
})

export const terminateTracking = () => ({ type: TERMINATE_TRACKING })